import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { INK, OLIVE, SERIF, BODY } from './DagbladFrontPage';
import DagbladKidWeek from './DagbladKidWeek';
import ChoreBoard, { todayYmd } from './ChoreBoard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };
const IMG = {
  elsa: 'https://static.prod-images.emergentagent.com/jobs/5f8564e9-242d-41fd-a450-5251f2a2d619/images/0a96619fb5ab67501a6b7ac4dd62232e92bf227d871c54d5963044d2b93e2a28.jpeg',
  clean: 'https://static.prod-images.emergentagent.com/jobs/5f8564e9-242d-41fd-a450-5251f2a2d619/images/9de16ae3801e12ef4732a508a74fe90984e12662a392e8b74523ed02c30061d5.jpeg',
  rocket: 'https://static.prod-images.emergentagent.com/jobs/5f8564e9-242d-41fd-a450-5251f2a2d619/images/7138b7e91450ed056b338b90bc1c0fc870e7dc48ebef93336d57ca275e095f7a.jpeg',
};
const DAY_COLORS = ['#FFE3EC', '#E3F0FF', '#E8FFE8', '#FFF4D6', '#F0E6FF', '#FFE8DC', '#E6FAF7'];
const PEP = ['Du är bättre på det här än du tror 💪', 'Små steg räknas också 🐾', 'Ingen perfektion, bara framsteg ✨', 'Kaffe först, sen världen ☕'];

const Card = ({ children, color, testid, className = '' }) => (
  <section className={`rounded-3xl border-[3px] p-4 sm:p-5 shadow-[4px_4px_0_#2B2620] ${className}`} style={{ borderColor: INK, background: color }} data-testid={testid}>{children}</section>
);

function Stat({ emoji, value, label, color, testid }) {
  return (
    <div className="rounded-2xl border-2 p-3 text-center transition-transform hover:-rotate-2 hover:scale-105" style={{ borderColor: INK, background: color }} data-testid={testid}>
      <div className="text-3xl">{emoji}</div>
      <div className="text-3xl font-black leading-none mt-1" style={{ fontFamily: SERIF }}>{value}</div>
      <div className="text-[11px] font-bold mt-1" style={{ fontFamily: BODY }}>{label}</div>
    </div>
  );
}

function MissedCleaning({ items: raw, onTick }) {
  const [all, setAll] = useState(false);
  const items = raw.filter((d) => !d.is_today);
  const today = raw.find((d) => d.is_today);
  if (!items.length) {
    return (
      <Card color="#E8FFE8" testid="weekly-cleaning-done">
        <div className="flex items-center gap-4">
          <img src={IMG.clean} alt="" className="w-20 h-20 rounded-2xl object-cover border-2" style={{ borderColor: INK }} />
          <p className="text-lg font-black" style={{ fontFamily: SERIF }}>Alla städrutiner är klara den här veckan! Hamstern dansar 🎉</p>
        </div>
      </Card>
    );
  }
  const left = items.reduce((n, d) => n + d.missed.length, 0);
  if (!left) {
    return (
      <Card color="#E8FFE8" testid="weekly-cleaning-done">
        <p className="text-lg font-black" style={{ fontFamily: SERIF }}>Inget missat från tidigare i veckan! 🎉 {today ? `Idag: ${today.room}, i lugn takt.` : ''}</p>
      </Card>
    );
  }
  return (
    <Card color="#FFF4D6" testid="weekly-cleaning-missed">
      <div className="flex items-center gap-4">
        <img src={IMG.clean} alt="" className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl object-cover border-2 flex-shrink-0" style={{ borderColor: INK }} />
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.3em] text-[#8C2F2F] animate-pulse">⚠️ Blinkar tills de är klara</p>
          <h3 className="text-2xl font-black leading-tight" style={{ fontFamily: SERIF }}>{left} städgrejer väntar på dig</h3>
          <p className="text-sm italic" style={{ fontFamily: BODY }}>Bocka av det du gjort, eller flytta en sak till idag. Ingen skam, bara en ny chans 💛</p>
        </div>
      </div>
      {!all && (
        <div className="mt-4 space-y-2" data-testid="weekly-missed-top3">
          {items.flatMap((d) => d.missed.map((m) => ({ d, m }))).slice(0, 3).map(({ d, m }) => (
            <div key={`${d.date}-${m.index}`} className="flex items-center gap-3 rounded-2xl px-3 py-2.5 border-2 animate-[blinkSoft_1.6s_ease-in-out_infinite]" style={{ borderColor: INK }} data-testid={`weekly-missed-${d.date}-${m.index}`}>
              <button onClick={() => onTick(d, m, false)} className="w-6 h-6 border-2 rounded-lg flex-shrink-0 bg-white hover:bg-[#B9F3D0]" style={{ borderColor: INK }} aria-label="Klart" data-testid={`weekly-missed-check-${d.date}-${m.index}`} />
              <span className="flex-1 text-[15px] font-bold" style={{ fontFamily: BODY }}>{d.emoji} {m.text} <span className="font-normal opacity-60">· {d.pretty.split(' ')[0].toLowerCase()}</span></span>
              <button onClick={() => onTick(d, m, true)} className="no-print text-[11px] font-black uppercase px-3 py-1.5 rounded-full text-white" style={{ background: OLIVE }} data-testid={`weekly-missed-today-${d.date}-${m.index}`}>Gör idag</button>
            </div>
          ))}
          {today && <p className="text-sm italic pt-1" style={{ fontFamily: BODY }} data-testid="weekly-today-cleaning">{today.emoji} Idag: {today.room}, {today.missed.length} saker. Ingen brådska, dagen är inte slut än 🌿</p>}
          {left > 3 && <button onClick={() => setAll(true)} className="no-print text-sm font-black underline underline-offset-4" style={{ color: OLIVE }} data-testid="weekly-missed-show-all">Visa alla {left} (en i taget räcker 💛)</button>}
        </div>
      )}
      {all && <div className="mt-4 grid sm:grid-cols-2 gap-3">
        {items.map((d) => (
          <div key={d.date} className="rounded-2xl border-2 border-dashed p-3 bg-white/70" style={{ borderColor: '#F5B841' }} data-testid={`weekly-missed-${d.date}`}>
            <p className="font-black text-sm">{d.emoji} {d.pretty} · {d.room}</p>
            {d.missed.map((m) => (
              <div key={m.index} className="mt-1.5 flex items-center gap-2 rounded-xl px-2 py-1.5 bg-[#FFE8A3]" data-testid={`weekly-missed-${d.date}-${m.index}`}>
                <button onClick={() => onTick(d, m, false)} className="w-5 h-5 border-2 rounded flex-shrink-0 bg-white hover:bg-[#B9F3D0]" style={{ borderColor: INK }} aria-label="Klart" data-testid={`weekly-missed-check-${d.date}-${m.index}`} />
                <span className="flex-1 text-sm" style={{ fontFamily: BODY }}>{m.text}</span>
                <button onClick={() => onTick(d, m, true)} className="no-print text-[10px] font-black uppercase px-2 py-1 rounded-full text-white" style={{ background: OLIVE }} data-testid={`weekly-missed-today-${d.date}-${m.index}`}>Gör idag</button>
              </div>
            ))}
          </div>
        ))}
        <button onClick={() => setAll(false)} className="no-print text-sm font-black underline" style={{ color: OLIVE }} data-testid="weekly-missed-show-less">Visa bara 3</button>
      </div>}
    </Card>
  );
}

function NextWeek({ d }) {
  const s = d.summary;
  return (
    <Card color="#F0E6FF" testid="weekly-next">
      <div className="flex items-center gap-4">
        <img src={IMG.rocket} alt="" className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl object-cover border-2 flex-shrink-0" style={{ borderColor: INK }} />
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.3em]" style={{ color: OLIVE }}>Kommande vecka · {d.next_week_label}</p>
          <h3 className="text-2xl font-black leading-tight" style={{ fontFamily: SERIF }} data-testid="weekly-summary-title">
            {s.events ? `${s.events} ${s.events === 1 ? 'händelse' : 'händelser'} väntar` : 'En lugn vecka väntar'} 🚀
          </h3>
          <p className="text-sm" style={{ fontFamily: BODY }} data-testid="weekly-summary">
            {Object.entries(s.kid_activities).filter(([, n]) => n).map(([k, n]) => `${k} har ${n} aktiviteter`).join(' · ')}
            {s.busiest ? ` · Mest händer ${s.busiest.toLowerCase()}` : ''}
            {s.calm_days.length ? ` · Lugna dagar: ${s.calm_days.join(', ').toLowerCase()} 🌿` : ''}
          </p>
        </div>
      </div>
      {s.highlights.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2" data-testid="weekly-highlights">
          {s.highlights.map((h) => <span key={h} className="rounded-full border-2 px-3 py-1 text-sm font-bold bg-white" style={{ borderColor: INK }}>📌 {h}</span>)}
        </div>
      )}
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {d.next_week.map((day, i) => (
          <div key={day.date} className="rounded-2xl border-2 p-3 transition-transform hover:-translate-y-1" style={{ borderColor: INK, background: DAY_COLORS[i] }} data-testid={`weekly-day-${day.date}`}>
            <p className="font-black" style={{ fontFamily: SERIF }}>{day.pretty}</p>
            {day.events.map((e) => <p key={e.title + e.time} className="text-sm mt-1" style={{ fontFamily: BODY }}>📌 {e.time ? <b>{e.time.replace(':', '.')} </b> : ''}{e.title}</p>)}
            {day.kids.filter((k) => k.activities.length).map((k) => <p key={k.name} className="text-sm mt-1" style={{ fontFamily: BODY }}>🎒 {k.name}: {k.activities.join(', ').toLowerCase()}</p>)}
            <p className="text-xs mt-1.5 opacity-70" style={{ fontFamily: BODY }}>{day.room.emoji} Städzon: {day.room.room}</p>
            {!day.events.length && !day.kids.some((k) => k.activities.length) && <p className="text-xs italic mt-1">Fri dag 🌼</p>}
          </div>
        ))}
      </div>
    </Card>
  );
}

export default function DagbladWeekly() {
  const [d, setD] = useState(null);
  const [ed, setEd] = useState(null);
  const pep = PEP[new Date().getDate() % PEP.length];
  const load = () => axios.get(`${API}/dagblad/weekly`, cfg).then((r) => {
    setD(r.data);
    if (r.data.editorial) setEd(r.data.editorial);
    else axios.post(`${API}/dagblad/weekly/editorial`, {}, { ...cfg, timeout: 60000 }).then((e) => setEd(e.data)).catch(() => {});
  }).catch(() => toast.error('Söndagsbilagan kom inte fram'));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const tickMissed = async (day, m, toToday) => {
    setD((cur) => ({ ...cur, missed_cleaning: cur.missed_cleaning.map((x) => (x.date === day.date ? { ...x, missed: x.missed.filter((y) => y.index !== m.index) } : x)).filter((x) => x.missed.length) }));
    try {
      await axios.post(`${API}/dagblad/weekly/room-check`, { date: day.date, index: m.index, done: true, to_today: toToday }, cfg);
      toast.success(toToday ? `🧹 "${m.text}" ligger nu i Idag-listan` : `✨ Snyggt! "${m.text}" är klart`);
    } catch { toast.error('Kunde inte spara'); load(); }
  };

  if (!d) return <p className="py-10 text-center italic" style={{ fontFamily: BODY }} data-testid="weekly-loading">Farmor Elsa bläddrar i veckan…</p>;
  const r = d.recap;
  return (
    <div className="mt-6 space-y-5" data-testid="dagblad-weekly">
      <style>{'@keyframes blinkSoft{0%,100%{background-color:#FFE8A3}50%{background-color:#FFC8DD}}'}</style>
      <Card color="#FFFBF2" testid="weekly-hero">
        <div className="flex flex-col sm:flex-row items-center gap-5">
          <img src={IMG.elsa} alt="Farmor Elsa läser tidningen" className="w-36 h-36 sm:w-44 sm:h-44 rounded-3xl object-cover border-[3px] -rotate-2" style={{ borderColor: INK }} data-testid="weekly-hero-img" />
          <div className="flex-1 text-center sm:text-left">
            {ed ? (
              <>
                <h2 className="text-3xl sm:text-4xl font-black leading-tight" style={{ fontFamily: SERIF }} data-testid="weekly-headline">{ed.headline}</h2>
                <p className="mt-2 text-[15px] leading-relaxed" style={{ fontFamily: BODY }} data-testid="weekly-lead">{ed.lead}</p>
                <p className="mt-2 inline-block rounded-full px-3 py-1 text-sm font-bold italic bg-[#FFE3EC] border-2" style={{ borderColor: INK, fontFamily: BODY }} data-testid="weekly-quote">💬 "{ed.elsa_quote}"</p>
              </>
            ) : <p className="italic" style={{ fontFamily: BODY }} data-testid="weekly-editorial-loading">Farmor Elsa skriver veckans krönika…</p>}
          </div>
        </div>
      </Card>

      <div className="rounded-full py-2 px-4 text-center font-black text-lg text-white -rotate-1" style={{ background: '#8C2F2F', fontFamily: SERIF }} data-testid="weekly-pep">{pep}</div>

      <Card color="#E3F0FF" testid="weekly-recap">
        <h3 className="text-2xl font-black mb-3" style={{ fontFamily: SERIF }}>Den här veckan fixade du 🏆</h3>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
          <Stat emoji="✅" value={r.tasks_done} label="klara uppgifter" color="#E8FFE8" testid="weekly-stat-tasks" />
          <Stat emoji="🌱" value={r.habit_ticks} label="vanor bockade" color="#FFF4D6" testid="weekly-stat-habits" />
          <Stat emoji="🐹" value={r.hp_passes} label="HP-pass" color="#FFE3EC" testid="weekly-stat-hp" />
          <Stat emoji="🏆" value={r.challenge_checkins} label="utmaningsdagar" color="#F0E6FF" testid="weekly-stat-challenges" />
          <Stat emoji="📱" value={r.distractions} label={r.top_distraction ? `distraktioner, mest ${r.top_distraction.toLowerCase()}` : 'distraktioner'} color="#FFE8DC" testid="weekly-stat-distractions" />
        </div>
        {Object.keys(r.stickers || {}).length > 0 && (
          <p className="mt-3 text-sm font-bold" style={{ fontFamily: BODY }} data-testid="weekly-stickers">
            🧸 {Object.entries(r.stickers).map(([k, v]) => `${k}: ${v.join(' ')}`).join(' · ')}
          </p>
        )}
      </Card>

      <DagbladKidWeek />
      <ChoreBoard date={todayYmd()} title="Städa vad? När? Det här är kvar" />
      <MissedCleaning items={d.missed_cleaning} onTick={tickMissed} />
      <NextWeek d={d} />
    </div>
  );
}
